'use strict';

import { connect } from 'react-redux';
import
{
	applicationStatusCodeSelector,
	ImportantMessageSelector,
	bottomTeasersSelector,
} from '../../selectors';

import menuData from './data/menuData';
import footerData from './data/footerData';
import React from 'react';

var VMA = require('../VMA');
var TMA = require('../TMA');
// Todo: decide name Header or Menu
var Menu = require('../menu/Menu.jsx');
var Footer = require('../Footer');
var Accesskeys = require('../accesskeys/Accesskeys.jsx');

const { List } = require('immutable');
const { loadImportantMessages, loadFirstpageEditorials } = require('../../actions');
const StatusMessage = require('../StatusMessage');
const BottomTeasers = require('../FirstpageHandler/BottomTeasers');

const Notifications = ({model}) => {
	if(!model || model.isEmpty()) {
		return (<noscript/>);
	}
	return (
		<div>
			{model.map((message, index) => {
				if(message.get('type') === 'vma') { return (<VMA key={index} message={message.toJS()}/>); }
				if(message.get('type') === 'tma') { return (<TMA key={index} message={message.toJS()}/>); }
				return (<noscript/>);
			})}
		</div>
	);
};

const PageNotFound = ({status, params, teasers}) => {
	return (
		<div>
			<StatusMessage status={status} key={`${status}-${Object.keys(params).map((key) => params[key]).join('-')}`}/>
			<BottomTeasers editorials={teasers.get('editorials', List())} otherEditorials={teasers.get('otherEditorials', List())}/>
		</div>
	);
};

class PageHandler extends React.Component {
	componentWillMount() {
		this.context.store.dispatch(loadImportantMessages);
	}

	componentWillReceiveProps(props) {
		if(props.location.pathname !== this.props.location.pathname) {
			this.context.store.dispatch(loadImportantMessages);
		}
	}

	render() {
		var search = this.props.location.query? this.props.location.query.q : '';
		return (<div className="svtse_application">
			<Accesskeys/>
			<Notifications model={this.props.messages}/>
			<div className="svtse_application__header-area">
				<Menu query={this.props.location.query} pathname={this.props.location.pathname} model={menuData} search={search} onSearch={this.onSearch}/>
			</div>
			<main className="svtse_application__main-area" id="svtse_accessKey--s" role="main" tabIndex="-1">
				{ this.props.status < 400 ? this.props.children : <PageNotFound {...this.props}/> }
			</main>
			<div className="svtse_application__footer-area">
				<Footer model={footerData}/>
			</div>
		</div>);
	}
}
PageHandler.handlerActions = [loadImportantMessages, loadFirstpageEditorials];
PageHandler.contextTypes = {
	store: React.PropTypes.object.isRequired,
};

function select(state, props) {
	return {
		messages: ImportantMessageSelector(state),
		status: applicationStatusCodeSelector(state),
		teasers: bottomTeasersSelector(state)
	};
}
export default connect(select)(PageHandler);



/** WEBPACK FOOTER **
 ** ./app/components/PageHandler/index.js
 **/